import { render } from "./Secao.vue?vue&type=template&id=5141ba3e&scoped=true"
import script from "./Secao.vue?vue&type=script&lang=js"
export * from "./Secao.vue?vue&type=script&lang=js"

import "./Secao.vue?vue&type=style&index=0&id=5141ba3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5141ba3e"]])

export default __exports__